import _Clear from "@material-ui/icons/esm/Clear";
import React from 'react';
import classnames from 'classnames';
import { detectIE } from '../../../utils/ui.utils';
import classes from './close-buttons.scss';
export default function CloseButton({
  onClick,
  IconComponent = null,
  className = undefined,
  dataButton = undefined,
  styles = {}
}) {
  const version = detectIE();
  const Icon = IconComponent || _Clear;
  return /*#__PURE__*/React.createElement("span", {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    viewBox: "2 2 20 20",
    className: classnames(classes.button, version && version < 12 ? classes.buttonIE : '', className),
    htmlColor: "white",
    "data-button": dataButton,
    style: styles
  }));
}